<template>
  <v-dialog v-model="sessionReplayStore.isStopDialogOpen" :persistent="sessionReplayStore.isSendingDescription" max-width="560">
    <v-card v-if="sessionReplayStore.result">
      <v-card-title class="c-modal__header">{{ $t("sessionReplay.finished") }}</v-card-title>
      <v-card-text class="text-body-2">
        <p class="mb-4">{{ $t("sessionReplay.explanation") }}</p>
        <k-textarea v-model="sessionReplayStore.description" name="description" :label="$t('sessionReplay.descriptionLabel')" :placeholder="$t('sessionReplay.descriptionPlaceholder')" rows="4" :maxlength="MAX_REPLAY_DESCRIPTION_LENGTH" :disabled="sessionReplayStore.isSendingDescription" />
        <div class="text-caption text-right">{{ sessionReplayStore.description.length }} / {{ MAX_REPLAY_DESCRIPTION_LENGTH }}</div>
        <v-alert v-if="sessionReplayStore.descriptionStatus === 'failed'" type="error" class="mt-4">{{ $t("sessionReplay.descriptionFailed") }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <k-button :disabled="sessionReplayStore.isSendingDescription" @click="sessionReplayStore.discardReport">{{ $t("global.cancel") }}</k-button>
        <k-button primary :disabled="sessionReplayStore.description.length > MAX_REPLAY_DESCRIPTION_LENGTH || sessionReplayStore.isSendingDescription" @click="sendReport">
          {{ $t(sessionReplayStore.isSendingDescription ? "sessionReplay.sendingDescription" : "sessionReplay.sendDescription") }}
        </k-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import { MAX_REPLAY_DESCRIPTION_LENGTH, useSessionReplayStore } from "@/store/sessionReplay"
import { useSnackbarsStore } from "@/store/snackbars"

const sessionReplayStore = useSessionReplayStore()
const snackbarsStore = useSnackbarsStore()
const { t } = useI18n()

async function sendReport() {
  await sessionReplayStore.sendDescription()
  if (sessionReplayStore.descriptionStatus === "sent") {
    snackbarsStore.success(t("sessionReplay.descriptionSent"), { timeout: 10000 })
  }
}
</script>
